import { Box } from "@mui/material";
import PostCard from "../../../../../components/MUI/cards/PostCard";
import classes from "./index.module.scss";
import { useDeferredValue } from "react";

export default function List({ posts }) {
  const deferredPosts = useDeferredValue(posts || []);
  if (!posts || !posts.length) return null;
  return (
    <Box component={"ul"} className={classes.list}>
      {deferredPosts?.map(
        ({ id, date, title, excerpt, img_url, post_tags, slug }) => (
          <Box key={id} component={"li"} className={classes.list__item}>
            <PostCard
              id={id}
              date={date}
              title={title}
              excerpt={excerpt}
              img_url={img_url}
              post_tags={post_tags}
              slug={slug}
            />
          </Box>
        )
      )}
    </Box>
  );
}
